import { render, staticRenderFns } from "./breadCrumbs.vue?vue&type=template&id=f5b8e178"
import script from "./breadCrumbs.vue?vue&type=script&lang=js"
export * from "./breadCrumbs.vue?vue&type=script&lang=js"
import style0 from "./breadCrumbs.vue?vue&type=style&index=0&id=f5b8e178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports